import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Warning from "@material-ui/icons/Warning";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

const useStyles = makeStyles((theme) => ({
    banner: {
        marginBottom: theme.spacing(2),
        borderRadius: "12px",
        background: "#fff8e1",
        border: "1px solid #ffe082",
    },
    content: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "14px",
        lineHeight: 1.6,
    },
    icon: {
        color: "#f57c00",
    },
    strong: {
        fontWeight: 700,
    },
}));

export default function NotInvestmentAdviceBanner() {
    const classes = useStyles();

    return (
        <Card className={classes.banner}>
            <CardBody>
                <div className={classes.content}>
                    <Warning className={classes.icon} />
                    <div>
                        <span className={classes.strong}>Wichtiger Hinweis:</span>{" "}
                        kimat-online stellt keine Anlageberatung, keine Anlagevermittlung
                        und keine Verm�gensverwaltung dar. Alle Inhalte dienen ausschlie�lich
                        Informationszwecken.
                    </div>
                </div>
            </CardBody>
        </Card>
    );
}